import { useContext } from "react";

import { EditQuoteActions, EditQuoteContextDispatch } from "components/Quotes/EditQuote/EditQuoteContext";

export function useEditQuoteActions(): EditQuoteActions {
    return useContext(EditQuoteContextDispatch)!;
};

export default useEditQuoteActions;
